<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('homepage.visit_table')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <el-row :gutter="15">
                        <el-col :sm="24" :md="24" :lg="12">
                            <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">
                                <img src="img/strategy/rahbar_image.jpg" class="image_card_rahbariyat_tashrif">
                                <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> 29.12.2022</span>
                                <div class="card_rahbariyat_tashrif_span_l">
                                    <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul1')}}</h5>
                                    <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro')}}</h6>
                                    <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro_main')}}</span>
                                    <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region10')}}</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="12">
                          <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">
                            <img src="img/strategy/rahbar_image_8.jpg" class="image_card_rahbariyat_tashrif">
                            <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> 03.02.2023</span>
                            <div class="card_rahbariyat_tashrif_span_l">
                              <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul5')}}</h5>
                              <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro1')}}</h6>
                              <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro1_main')}}</span>
                              <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region10')}}</span>
                            </div>
                          </div>
                        </el-col>
<!--                        <el-col :sm="24" :md="24" :lg="12">-->
<!--                        <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">-->
<!--                          <img src="img/strategy/rahbar_image_2.jpg" class="image_card_rahbariyat_tashrif">-->
<!--                          <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> 28.04.2021</span>-->
<!--                          <div class="card_rahbariyat_tashrif_span_l">-->
<!--                            <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul3')}}</h5>-->
<!--                            <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro3')}}</h6>-->
<!--                            <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro2_main')}}</span>-->
<!--                            <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region6')}}</span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </el-col>-->
                        <el-col :sm="24" :md="24" :lg="12">
                        <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">
                          <img src="img/strategy/rahbar_image_3.jpg" class="image_card_rahbariyat_tashrif">
                          <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> 25.01.2023</span>
                          <div class="card_rahbariyat_tashrif_span_l">
                            <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul5')}}</h5>
                            <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro4')}}</h6>
                            <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro2_main')}}</span>
                            <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region10')}}</span>
                          </div>
                        </div>
                      </el-col>
                        <el-col :sm="24" :md="24" :lg="12">
                          <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">
                            <img src="img/strategy/rahbar_image_9.jpg" class="image_card_rahbariyat_tashrif">
                            <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> (14-16).05.2022</span>
                            <div class="card_rahbariyat_tashrif_span_l">
                              <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul3')}}</h5>
                              <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro2')}}</h6>
                              <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro2_main')}}</span>
                              <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region6')}}</span>
                            </div>
                          </div>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="12">
                            <div class="card card-lift shadow border-0 card-rahbariyat_pro_tashrif  mb-3 mb-lg-3">
                                <img src="img/strategy/rahbar_image_10.jpg" class="image_card_rahbariyat_tashrif">
                                <span class="card-rahbariyat_status_tashrif"><i class="el-icon-date"></i> 22.11.2022</span>
                                <div class="card_rahbariyat_tashrif_span_l">
                                    <h5 class="rahbariyat_tashrif_name">{{$t('sayyor_qabul.qanul5')}}</h5>
                                    <h6 class="rahbariyat_tashrif_fio"><i class="el-icon-user"></i> {{$t('rahbariyat.boshpro5')}}</h6>
                                    <span class="pro_tashrif_status"><i class="el-icon-suitcase"></i> {{$t('rahbariyat.boshpro5_main')}}</span>
                                    <span class="pro_tashrif_status"><i class="el-icon-location-outline"></i> {{$t('app.bosh_region10')}}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped>
    /deep/ .px-4 {
        min-height: 356px;
    }

    /deep/ .profile-page .card-profile {
        margin-top: 70px;
    }
</style>
